import { Box } from "@chakra-ui/react";
import * as React from "react";

export function VideoLogo({ ...props }: any) {
  return (
    <Box>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="20" cy="20" r="20" fill="#0073E0" fill-opacity="0.42" />
        <path
          d="M25.7 29.3354C24.528 29.5 22.9996 29.5 20.95 29.5H19.05C15.0195 29.5 13.0042 29.5 11.7521 28.2479C10.5 26.9958 10.5 24.9805 10.5 20.95V19.05C10.5 15.0195 10.5 13.0042 11.7521 11.7521C13.0042 10.5 15.0195 10.5 19.05 10.5H20.95C24.9805 10.5 26.9958 10.5 28.2479 11.7521C29.5 13.0042 29.5 15.0195 29.5 19.05V20.95C29.5 22.1582 29.5 23.1853 29.4663 24.0651C29.4392 24.7701 29.4257 25.1227 29.1587 25.2544C28.8917 25.3861 28.5931 25.1748 27.9958 24.7522L26.65 23.8"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.9453 20.3948C22.7686 21.0215 21.9333 21.4644 20.2629 22.3502C18.648 23.2064 17.8406 23.6346 17.1899 23.4625C16.9209 23.3913 16.6758 23.2562 16.4781 23.07C16 22.6198 16 21.7465 16 20C16 18.2535 16 17.3802 16.4781 16.9299C16.6758 16.7438 16.9209 16.6087 17.1899 16.5375C17.8406 16.3654 18.648 16.7936 20.2629 17.6498C21.9333 18.5356 22.7686 18.9785 22.9453 19.6052C23.0182 19.8639 23.0182 20.1361 22.9453 20.3948Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}

export default VideoLogo;
